



























import 'reflect-metadata'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import Loader from '@/components/misc/Loader.vue'
import TransactionSummary from '@/components/Transaction/TransactionSummary.vue'
import TransactionUTXO from '@/components/TransactionUTXO.vue'
import HTTPError from '@/components/misc/HTTPError.vue'
import { TransactionsGettersMixin } from '@/store/modules/transactions/transactions.mixins'
import { getMappingForType } from '@/store/modules/transactions/maps'

@Component({
    components: {
        Loader,
        TransactionSummary,
        TransactionUTXO,
        HTTPError,
    },
    filters: {
        getType: getMappingForType,
    },
})
export default class TransactionPage extends Mixins(TransactionsGettersMixin) {
    loading = false
    breadcrumbs: any = [
        {
            text: 'Home',
            disabled: false,
            href: '/',
        },
        {
            text: 'Transactions',
            disabled: false,
            href: '/tx',
        },
        {
            text: 'Detail',
            disabled: true,
            href: '',
        },
    ]

    @Watch('txId')
    ontxIdChanged() {
        this.getData()
    }

    @Watch('assetsLoaded')
    onAssetsLoaded() {
        this.getData()
    }

    created() {
        this.getData()
    }

    get assetsLoaded() {
        return this.$store.state.assetsLoaded
    }

    get txId(): string {
        return this.$route.params.id
    }

    get tx() {
        return this.getTx()
    }

    getData(): void {
        this.loading = true
        if (this.assetsLoaded) {
            this.$store
                .dispatch('Transactions/getTx', {
                    id: this.txId,
                })
                .then(() => {
                    this.loading = false
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }
}
